import React from "react";
import { Text } from "@react-pdf/renderer";
import { reportStyles } from "./styles";

export const ReportFooter = () => {
  return (
    <Text style={reportStyles.footer}>
      Generated by D3 Dashboard • {new Date().toLocaleDateString()}
    </Text>
  );
};
